"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConnectionManager_1 = require("./../ConnectionManager");
var MenuLayer_1 = require("./MenuLayer");
var GameConstants_1 = require("./../GameConstants");
var FinishLayer_1 = require("./FinishLayer");
var WaitingServerLayer_1 = require("./WaitingServerLayer");
var AudioManager_1 = require("../AudioManager");
var GameVars_1 = require("../GameVars");
var Board_1 = require("./Board");
var BoardManager_1 = require("./BoardManager");
var GUI_1 = require("./GUI");
var HUD_1 = require("./HUD/HUD");
var LocalServer_1 = require("../LocalServer");
var BoardState = /** @class */ (function (_super) {
    __extends(BoardState, _super);
    function BoardState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BoardState.prototype.init = function () {
        BoardState.currentInstance = this;
        this.boardManager = new BoardManager_1.BoardManager(this.game);
        AudioManager_1.AudioManager.getInstance().playSound("music", 1, true);
    };
    BoardState.prototype.create = function () {
        var _this = this;
        gamezop.setState({
            state: "playing",
            score: 0,
            metadata: oMetaManager.meta
        });
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var shadow;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(GameVars_1.GameVars.gzpGameMode !== "casual")) return [3 /*break*/, 2];
                        return [4 /*yield*/, ConnectionManager_1.ConnectionManager.init(this.game)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        GameVars_1.GameVars.moves = 0;
                        this.game.physics.startSystem(Phaser.Physics.ARCADE);
                        this.bck = this.add.sprite(0, 0, "bg");
                        shadow = this.add.image(0, 0, "texture_atlas_1", "shadow_focus");
                        shadow.scale.y = GameVars_1.GameVars.scaleY;
                        shadow = this.add.image(0, GameConstants_1.GameConstants.GAME_HEIGHT, "texture_atlas_1", "shadow_focus");
                        shadow.scale.y = -GameVars_1.GameVars.scaleY;
                        this.hud = new HUD_1.HUD(this.game);
                        this.board = new Board_1.Board(this.game);
                        this.add.existing(this.board);
                        this.add.existing(this.hud);
                        this.gui = new GUI_1.GUI(this.game);
                        this.add.existing(this.gui);
                        this.waitingServerLayer = new WaitingServerLayer_1.WaitingServerLayer(this.game);
                        this.add.existing(this.waitingServerLayer);
                        this.menuLayer = new MenuLayer_1.MenuLayer(this.game);
                        this.menuLayer.visible = false;
                        this.add.existing(this.menuLayer);
                        this.game.camera.flash(0x000000, GameConstants_1.GameConstants.TIME_FADE, false);
                        return [2 /*return*/];
                }
            });
        }); })();
        if (GameVars_1.GameVars.gzpGameMode === "casual") {
            LocalServer_1.LocalServer.init();
            this.startGame();
        }
    };
    BoardState.prototype.shutdown = function () {
        BoardState.currentInstance = null;
        _super.prototype.shutdown.call(this);
    };
    BoardState.prototype.render = function () {
        if (GameConstants_1.GameConstants.SHOW_BOUNDING_AREAS) {
            for (var i = 0, ln = this.board.cards.length; i < ln; i++) {
                this.game.debug.body(this.board.cards[i]);
            }
            for (var i = 0; i < 4; i++) {
                this.game.debug.body(this.board.piles[i]);
            }
        }
    };
    BoardState.prototype.update = function () {
        _super.prototype.update.call(this);
    };
    BoardState.prototype.showMenuLayer = function () {
        this.menuLayer.visible = true;
    };
    BoardState.prototype.hideMenuLayer = function () {
        this.menuLayer.visible = false;
    };
    BoardState.prototype.showWaitingServerLayer = function () {
        this.waitingServerLayer.show();
    };
    BoardState.prototype.hideWaitingServerLayer = function () {
        this.waitingServerLayer.visible = false;
    };
    BoardState.prototype.startedGame = function () {
        this.boardManager.startedGame();
        this.hud.startGame();
    };
    BoardState.prototype.startGame = function () {
        this.boardManager.startGame();
    };
    BoardState.prototype.reset = function () {
        this.game.state.restart(true, false);
    };
    BoardState.prototype.showFinishLayer = function (win) {
        this.menuLayer.visible = false;
        var finishLayer = new FinishLayer_1.FinishLayer(this.game, win);
        this.add.existing(finishLayer);
    };
    return BoardState;
}(Phaser.State));
exports.BoardState = BoardState;
